export const paymentStatusEnum = {
  SUCCESS: "success",
  FAILED: "failed",
  ERROR: "error",
  PENDING: "pending",
};
